<div class="list">

  <div class="d__flex ion-align-items-center just-s header__part">
    <h6>Select Categories</h6>
    <div class="d__flex ion-align-items-center">
      <ion-button fill="clear" size="small" class="fnt-16 ion-text-capitalize"  (click)="modalCtrl.dismiss()">Close</ion-button>
      <ion-button fill="clear" size="small" class="fnt-16 ion-text-capitalize save_btn" color="primary-bg" (click)="save_value()">Save</ion-button>
    </div>
  </div>

  <div  #search_dropdown class="d__flex border web__searchbar search_box" [ngClass]="'search_down'? 'focused':''">
    <ion-input #search (input)="getItems($event)" name="search" placeholder="Search categories"></ion-input>
    <ion-icon class="f24" src="assets/icon/search.svg" slot="end"></ion-icon>
  </div>
  
  
  <div class="categories">
    <div class="ion-activatable ripple-parent rectangle mouse" (click)="check_parent(item)" *ngFor="let item of category_list">
      <ion-ripple-effect></ion-ripple-effect>
       <div *ngIf="!item.child_value" class="d__flex box">
         <ion-label>{{item.category_name}}</ion-label>
         <ion-toggle mode="ios" (ionChange)="check_parent1($event,item)"   [(ngModel)]="item.selected"></ion-toggle>
       </div>

  <!-- <div  *ngIf="item.child && item.child.length != 0">
        <div *ngFor="let sub_item of item.child" class="" >
         <div *ngIf="!item.child_value" class="d__flex box" >
          <ion-label>{{sub_item.category_name}}</ion-label>
          <ion-toggle mode="ios" (ionChange)="check_sub_child($event,sub_item)" [(ngModel)]="sub_item.selected" ></ion-toggle>
         </div>
  
         <div  *ngIf="sub_item.child && sub_item.child.length != 0">
          <div *ngFor="let sub of sub_item.child" class="d__flex box" >
           <ion-label>{{sub.category_name}}</ion-label>
           <ion-toggle mode="ios" (ionChange)="check_sub_child1($event,sub)" [(ngModel)]="sub.selected" ></ion-toggle>
          </div>
         </div>
        </div>
       </div> -->
    </div>
  
  </div> 

</div>
  
